import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-srm-image',
  templateUrl: './srm-image.component.html',
  styleUrls: ['./srm-image.component.css'],
})
export class SrmImageComponent implements OnChanges {
  @Input() imagemSrmUrl?: string | null;
  @Input() alt = 'SRM';
  @Input() width = '30%';
  isLoading = false;
  hasError = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imagemSrmUrl']) {
      this.isLoading = !!this.imagemSrmUrl;
      this.hasError = false;
    }
  }

  onLoad(): void {
    this.isLoading = false;
    this.hasError = false;
  }

  onError(): void {
    this.isLoading = false;
    this.hasError = true;
  }

  get imagemSrmGpkgUrl(): string | null {
    const imagemUrl = this.imagemSrmUrl;
    if (!imagemUrl) {
      return null;
    }

    return imagemUrl.replace(/\.png(?=($|\?))/i, '.gpkg');
  }

  get nomeArquivoSrmPng(): string {
    const imagemUrl = this.imagemSrmUrl;
    if (!imagemUrl) {
      return 'srm.png';
    }

    const semQuery = imagemUrl.split('?')[0];
    return semQuery.substring(semQuery.lastIndexOf('/') + 1) || 'srm.png';
  }

  get nomeArquivoSrmGpkg(): string {
    const gpkgUrl = this.imagemSrmGpkgUrl;
    if (!gpkgUrl) {
      return 'srm.gpkg';
    }

    const semQuery = gpkgUrl.split('?')[0];
    return semQuery.substring(semQuery.lastIndexOf('/') + 1) || 'srm.gpkg';
  }

  downloadFile(url: string | null | undefined, fileName: string): void {
    if (!url) {
      return;
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
